<template>
	<div class="l-body">
		<Top/>
		<div class="wrap" :class="bgId">
			<div class="l-wrap zheng">
				<div class="faqtit"><span id="game">{{game}}</span><span>-</span><span id="faqtype">常见问题</span></div>
					<div class="faq_changjian" style="cursor:pointer">
						<a @click="change($event)" :class="show==true?'ok':''" v-show="yy">安全服务相关问题</a>
						<a @click="change1($event)" :class="show1==true?'ok':''" v-show="yy">查询找回相关问题</a>
						<a @click="change2($event)" :class="show2==true?'ok':''" v-show="yy">账号服务相关问题</a>
						<a @click="change4($event)" :class="show4==true?'ok':''"v-show="yy1">贵宾服务相关问题</a>
						<a @click="change3($event)" :class="show3==true?'ok':''" v-show="yy">其他问题</a>
					</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow1">
					<router-view/>
				</div>
				<div class="sp tcs1" v-show="qq">
							<div class="spinners bs02">
								<i id="colose" @click="tv"></i>
								<div class="tc_zhengwen">
							<h1 class="tcbiaoti">贵宾专属通道</h1>
							<div class="tczwtxt tczwt1">
								<li><p>电话服务：15340256711</p></li>
								<li><p>企业QQ：800103377</p><span><a href="tencent://message/?uin=800103377&Site=Sambow&Menu=yes">打开QQ服务</a></span></li>
								<li><p>贵宾专用邮箱：guibin@zhaouc.com</p></li>
								<li><p>接待时间：365*24小时在线贵宾专属通道</p></li>
							</div>
								</div>
				  </div>
				</div>
				<div class="help-jl-box" style="width:100%;" v-show="theshow">
					<h1><span id="game">{{game}}</span><span>-</span><span id="faqtype">{{antext}}</span></h1>
					<h2>customer service</h2>
					<div class="wentilist" style="width:90%;margin-left:55px" v-show="sun">
						<ul id="nav" v-show="show">
						<li class="list"><i></i><a @click="t('sun1')"><h3>微信令宝使用说明</h3></a></li>
						<li class="list"><i></i><a @click="t('sun2')"><h3>微信令宝介绍</h3></a></li>
						<li class="list"><i></i><a @click="t('sun3')"><h3>令宝解绑申请</h3></a></li>
						</ul>
						<ul id="nav" v-show="show1">
						<li class="list"><i></i><a @click="t('sun4')"><h3>物品被盗如何申请找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun5')"><h3>角色恢复</h3></a></li>
						<li class="list"><i></i><a @click="t('sun6')"><h3>物品丢失、物品异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun7')"><h3>买到被盗物品怎么办</h3></a></li>
						<li class="list"><i></i><a @click="t('sun8')"><h3>防盗防骗小常识</h3></a></li>
						</ul>
						<ul id="nav" v-show="show2">
						<!-- <li class="list"><i></i><a @click="t('sun25')"><h3>子账号换绑异身份证主账号</h3></a></li>
						<li class="list"><i></i><a @click="t('sun26')"><h3>子账号换绑同身份证主账号</h3></a></li> -->
						<li class="list"><i></i><a @click="t('sun27')"><h3>奇迹世界SUN修改绑定邮箱</h3></a></li>
						<li class="list"><i></i><a @click="t('sun10')"><h3>SUN1修改身份证信息</h3></a></li>
						<li class="list"><i></i><a @click="t('sun11')"><h3>停封解封申请</h3></a></li>
						<li class="list"><i></i><a @click="t('sun12')"><h3>账号找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun13')"><h3>修改密码</h3></a></li>
						<li class="list"><i></i><a @click="t('sun14')"><h3>仓库密码找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun15')"><h3>证件号核实</h3></a></li>
						<li class="list"><i></i><a @click="t('sun16')"><h3>视频认证服务</h3></a></li>
						<li class="list"><i></i><a @click="t('sun17')"><h3>SUN1账号注销</h3></a></li>
						<li class="list"><i></i><a @click="t('sun9')"><h3>奇迹世界SUN身份证信息重置</h3></a></li>
						</ul>
						<ul id="nav" v-show="show3">
						<li class="list"><i></i><a @click="t('sun18')"><h3>举报违规、封停申诉</h3></a></li>
						<li class="list"><i></i><a @click="t('sun19')"><h3>踢线处理</h3></a></li>
						<li class="list"><i></i><a @click="t('sun20')"><h3>登录异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun21')"><h3>预约来访</h3></a></li>
						<li class="list"><i></i><a @click="t('sun22')"><h3>意见建议、问题提交</h3></a></li>
						<li class="list"><i></i><a @click="t('sun23')"><h3>发票开具</h3></a></li>
						</ul>
						<ul id="nav" v-show="show4">
						<li class="list"><i></i><a @click="t('sun24')"><h3>贵宾特权说明</h3></a></li>
						<li class="list"><i></i><a @click="t('vip')"><h3>常见问题说明</h3></a></li>
						<li class="list"><i></i><a @click="tt"><h3>贵宾专属通道</h3></a></li>
						<li class="list"><i></i><a @click="t('vip1')"><h3>免费洗红申请</h3></a></li>
						<li class="list"><i></i><a @click="t('vip2')"><h3>什么是贵宾用户</h3></a></li>
						</ul>
					</div>
					<div class="wentilist" style="width:90%;margin-left:55px" v-show="mu">
						<ul id="nav" v-show="show">
						<li class="list"><i></i><a @click="t('sun1')"><h3>微信令宝使用说明</h3></a></li>
						<li class="list"><i></i><a @click="t('sun2')"><h3>微信令宝介绍</h3></a></li>
						<li class="list"><i></i><a @click="t('sun3')"><h3>令宝解绑申请</h3></a></li>
						</ul>
						<ul id="nav" v-show="show1">
						<li class="list"><i></i><a @click="t('mu1')"><h3>物品被盗如何申请找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun5')"><h3>角色恢复</h3></a></li>
						<li class="list"><i></i><a @click="t('mu11')"><h3>物品丢失、物品异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun7')"><h3>买到被盗物品怎么办</h3></a></li>
						<li class="list"><i></i><a @click="t('sun8')"><h3>防盗防骗小常识</h3></a></li>
						</ul>
						<ul id="nav" v-show="show2">
						<li class="list"><i></i><a @click="t('mu2')"><h3>修改绑定邮箱</h3></a></li>
						<li class="list"><i></i><a @click="t('mu3')"><h3>证件信息修改</h3></a></li>
						<li class="list"><i></i><a @click="t('sun11')"><h3>停封解封申请</h3></a></li>
						<li class="list"><i></i><a @click="t('mu6')"><h3>账号找回</h3></a></li>
						<li class="list"><i></i><a @click="t('mu4')"><h3>修改密码</h3></a></li>
						<li class="list"><i></i><a @click="t('mu5')"><h3>仓库密码找回</h3></a></li>
						<li class="list"><i></i><a @click="t('sun15')"><h3>证件号核实</h3></a></li>
						<li class="list"><i></i><a @click="t('sun16')"><h3>视频认证服务</h3></a></li>
						<li class="list"><i></i><a @click="t('mu7')"><h3>账号注销</h3></a></li>
						</ul>
						<ul id="nav" v-show="show3">
						<li class="list"><i></i><a @click="t('mu8')"><h3>举报违规、封停申诉</h3></a></li>
						<li class="list"><i></i><a @click="t('sun19')"><h3>踢线处理</h3></a></li>
						<li class="list"><i></i><a @click="t('mu9')"><h3>登录异常</h3></a></li>
						<li class="list"><i></i><a @click="t('sun21')"><h3>预约来访</h3></a></li>
						<li class="list"><i></i><a @click="t('sun22')"><h3>意见建议、问题提交</h3></a></li>
						<li class="list"><i></i><a @click="t('sun23')"><h3>发票开具</h3></a></li>
						</ul>
						<ul id="nav" v-show="show4">
						<li class="list"><i></i><a @click="t('mu10')"><h3>贵宾特权说明</h3></a></li>
						<li class="list"><i></i><a @click="t('vip')"><h3>常见问题说明</h3></a></li>
						<li class="list"><i></i><a @click="tt"><h3>贵宾专属通道</h3></a></li>
						<li class="list"><i></i><a @click="t('vip2')"><h3>什么是贵宾用户</h3></a></li>
						</ul>
					</div>
					<div class="wentilist" style="width:90%;margin-left:55px" v-show="mu2">
						<ul id="nav" v-show="show">
						<li class="list"><i></i><a @click="t('vip')"><h3>常见问题说明</h3></a></li>
						<li class="list"><i></i><a @click="tt"><h3>贵宾专属通道</h3></a></li>
						<li class="list"><i></i><a @click="t('vip2')"><h3>什么是贵宾用户</h3></a></li>
						</ul>
					</div>
					<div class="wentilist" style="width:90%;margin-left:55px" v-show="ro">
						<ul id="nav" v-show="show">
						<li class="list"><i></i><a @click="t('sun1')"><h3>微信令宝使用说明</h3></a></li>
						<li class="list"><i></i><a @click="t('sun2')"><h3>微信令宝介绍</h3></a></li>
						<li class="list"><i></i><a @click="t('sun3')"><h3>令宝解绑申请</h3></a></li>
						<li class="list"><i></i><a @click="t('ro1')"><h3>账号登陆保护设置</h3></a></li>
						</ul>
						<ul id="nav" v-show="show1">
						<li class="list"><i></i><a @click="t('ro2')"><h3>物品被盗如何申请找回</h3></a></li>
						<li class="list"><i></i><a @click="t('ro3')"><h3>物品丢失、物品异常</h3></a></li>
						<li class="list"><i></i><a @click="t('ro4')"><h3>买到被盗物品怎么办</h3></a></li>
						<li class="list"><i></i><a @click="t('sun8')"><h3>防盗防骗小常识</h3></a></li>
						</ul>
						<ul id="nav" v-show="show2">
						<li class="list"><i></i><a @click="t('ro5')"><h3>修改绑定邮箱或(及)手机号码</h3></a></li>
						<li class="list"><i></i><a @click="t('ro6')"><h3>停封解封申请</h3></a></li>
						<li class="list"><i></i><a @click="t('ro7')"><h3>账号找回</h3></a></li>
						<li class="list"><i></i><a @click="t('ro8')"><h3>修改密码</h3></a></li>
						<li class="list"><i></i><a @click="t('sun15')"><h3>证件号核实</h3></a></li>
						<li class="list"><i></i><a @click="t('ro9')"><h3>视频认证服务</h3></a></li>
						<!-- <li class="list"><i></i><a @click="t('/common/ro10')"><h3>账号注销</h3></a></li> -->
						<li class="list"><i></i><a @click="t('ro11')"><h3>未通过实名认证账号身份信息更改</h3></a></li>
						</ul>
						<ul id="nav" v-show="show3">
						<li class="list"><i></i><a @click="t('sun18')"><h3>举报违规、封停申诉</h3></a></li>
						<li class="list"><i></i><a @click="t('sun22')"><h3>意见建议、问题提交</h3></a></li>
						</ul>
					</div>
					<div class="hujiao" style="float:left;">
						<p>您的问题是否得到了解决？如果没有，您可以尝试：</p>
						<p>呼叫在线客服：<a href='http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf'>在线客服</a></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Top from '@/components/top1.vue';
  export default {
    name: "common",
    components: {
      Top,
    },
	data () {
	  return {
	    id:this.$route.query.id||localStorage.getItem('id'),
	    game:this.$route.query.name||localStorage.getItem('game'),
		cname:this.$route.query.cname||' ',
	    bgId:'',
		sun:false,
		mu:false,
		mu2:false,
		ro:false,
		yy:true,
		yy1:true,
		qq:false,
		show:true,
		show1:false,
		show2:false,
		show3:false,
		show4:false,
		theshow:true,
		theshow1:false,
		antext:'安全服务相关问题'
	  }
	},
	created() {
	  this.gameBg()
	  if(this.cname!=' '){
		 this.t1()
	  }
	  localStorage.setItem('id',this.id)
	  localStorage.setItem('game', this.game)
	},
	watch: {
		$route(to , from){
			if(to.path=='/common'){
				this.theshow=true
				this.theshow1=false
			}
		}
	 },
	methods:{
	  gameBg(){
	    if(this.id==1){
	      this.bgId='sun'
		  this.sun=true
	    }else if(this.id==2){
	      this.bgId='mu'
		  this.mu=true
	    }else if(this.id==4){
		  this.bgId='ro'
		  this.ro=true
		  this.yy1=false
		}else if(this.id==3){
	      this.bgId='mu2'
		  this.mu2=true
		  this.yy=false
		  this.show4=true
		  this.antext='贵宾服务相关问题'
	    }else if(this.id==5){
	      this.bgId='moli'
	    }
	  },
	  change(val){
		 this.show=true;
		 this.show1=false;
		 this.show2=false;
		 this.show3=false;
		 this.show4=false
		 this.theshow=true
		 this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change1(val){
	  	this.show1=true;
	  	this.show=false;
	  	this.show2=false;
	  	this.show3=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change2(val){
		this.show2=true;
		this.show1=false;
		this.show=false;
		this.show3=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText 
	  },
	  change3(val){
		this.show3=true;
		this.show1=false;
		this.show2=false;
		this.show=false;
		this.show4=false
		this.theshow=true
		this.theshow1=false
		this.antext=val.target.innerText
	  },
	  change4(val){
		  if(this.id==3){
			this.show=true;
		  }else{
			this.show3=false;
			this.show1=false;
			this.show2=false; 
			this.show=false;
		  }
		  this.show4=true
		this.theshow=true
		this.theshow1=false
	  	this.antext=val.target.innerText
	  },
	  tt(){
		  this.qq=true
	  },
	  tv(){
		  this.qq=false
	  },
	  t(meg){
		  this.theshow=false
		  this.theshow1=true
		  this.$router.push({path:'/common/'+meg,query:{id:this.id,game:this.game,cname:meg}})
	  },
	  t1(){
		  this.theshow=false
		  this.theshow1=true
		  var meg=this.cname
		  this.$router.push({path:'/common/'+meg,query:{id:this.id,game:this.game,cname:meg}})
	  }
	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/common.vue